import React, { useCallback, useRef } from 'react';
import { Keyboard } from 'react-native';
import { useRefCallback } from 'hooks';
import Modal from 'utils/packages/Modal';
import { useAppDispatch } from 'store/hooks';
import { getIncomes } from 'actions';
import { useRequiredBenefitCallbackWithSpaces } from 'features/premium/hooks/useRequiredBenefitCallback';
import useShouldShowUpgrade from 'features/premium/hooks/useShouldShowUpgrade';
import RollingBudgetModalContent from '../components/RollingBudgetModalContent';
import { getBudgets } from '../actions';
const strings = {
    titleEnable: 'Would you like to enable rolling budgets?',
    titleDisable: 'Would you like to stop rolling budgets?',
};
export const useBudgetSetRolloverModal = (onAllowEdit, onSave, toggleSwitchState, flow) => {
    const dispatch = useAppDispatch();
    const { isUnlockedForSpace } = useShouldShowUpgrade({
        benefitId: 'rollingBudgets',
    });
    const valueRef = useRef(false);
    const onContinue = useCallback(() => {
        const value = valueRef.current;
        onAllowEdit(value);
        if (flow !== 'Confirm') {
            onSave?.(value);
            dispatch(getBudgets());
            dispatch(getIncomes());
        }
    }, [flow, onAllowEdit, onSave]);
    const guardedOnContinue = useRequiredBenefitCallbackWithSpaces(onContinue, 'rollingBudgets');
    const handleContinue = useCallback(() => {
        if (!isUnlockedForSpace) {
            toggleSwitchState?.();
            guardedOnContinue();
            setTimeout(() => {
                Modal.hide();
            }, 300);
        }
        else {
            Modal.hide();
            guardedOnContinue();
        }
    }, [guardedOnContinue, isUnlockedForSpace, toggleSwitchState]);
    const showModal = useRefCallback((value) => {
        valueRef.current = value;
        Keyboard.dismiss();
        Modal.show(<RollingBudgetModalContent onPressContinue={handleContinue} onPressCancel={() => {
                toggleSwitchState?.();
                Modal.hide();
            }} isEnabling={value}/>, {
            title: value ? strings.titleEnable : strings.titleDisable,
            onBackdropPress: toggleSwitchState,
            onSwipeComplete: toggleSwitchState,
        });
    });
    return (value, muteModal = false) => {
        if (muteModal) {
            guardedOnContinue();
            return;
        }
        showModal(value);
    };
};
